import React from "react";
import cls from "classnames";

import styles from "./styles.scss";

interface PageProps {
  style: React.CSSProperties;
  bgImage?: string;
  className?: string;
  children?: React.ReactNode;
}

const Page = (props: PageProps): JSX.Element => {
  return (
    <div
      style={{
        ...props.style,
        backgroundImage: props.bgImage ? `url(${props.bgImage})` : undefined,
      }}
      className={cls(styles.page, props.className)}
    >
      {props.children}
    </div>
  );
};

export default Page;
